import React from 'react';
import { useIntl } from 'react-intl';
import { formatClock } from '../utils/timeZone';

export const WindowHeader = ({ window, timeZone, canPrev, canNext, onMove }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="request-video-window-header">
      <button
        type="button"
        disabled={!canPrev}
        aria-label={formatMessage({ id: 'requestVideo_window_prev' })}
        onClick={() => onMove(-1)}
      >
        &laquo;
      </button>
      <strong>
        {formatMessage({ id: 'requestVideo_window_title' })}: {formatClock(window.start, timeZone)} -{' '}
        {formatClock(window.end, timeZone)}
      </strong>
      <button
        type="button"
        disabled={!canNext}
        aria-label={formatMessage({ id: 'requestVideo_window_next' })}
        onClick={() => onMove(1)}
      >
        &raquo;
      </button>
    </div>
  );
};
